import styled from 'styled-components';
import { variables } from 'variables';

export const DraggableContainer = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: lightgray 0px 0px 24px 5px;
  border: 2px solid lightgray;
  // min-height: ${variables.windowHeight}px;
  overflow: auto;
  resize: vertical !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media only screen and (max-width: 960px) {
    width: 100%;
    margin-bottom: 12px;
    margin-right: 0;
  }
`;

export const TopBar = styled.div`
  padding: 12px 5px 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d8d8d8;
  height: 5.3em;
  i {
    font-size: 18px;
    cursor: pointer;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  h5 {
    margin: 3px 12px 0 5px;
  }
  .count {
    color: red;
    margin: 0;
    margin-right: 8px;
    font-weight: bold;
    border: 1px solid red;
    border-radius: 50%;
    padding: 3px 9px;
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 12px 18px;
  @media only screen and (max-width: 1440px) {
    padding: 12px;
  }
`;

export const NotificationContainer = styled.div`
  padding: 0 8px 0 3px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  border-radius: 3px;
  i {
    cursor: pointer;
  }
`;

export const Alert = styled.div`
  padding: 12px 14px;
  h6 {
    margin: 0;
  }
  p {
    margin: 0;
    color: gray;
    margin-top: 3px;
  }
`;

export const TradeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0.7em 1.5em;
  p {
    margin: 0;
    cursor: pointer;
    text-decoration: underline;
    font-weight: bold;
  }
  .space {
    margin: 0 8px;
  }
`;
